/**
 * Notification Container Component
 * Add this component inside MainLayout to render the cart notification container
 * This creates a div where notistack will render cart notifications
 */
export const NotificationContainer = () => {
  return <div id="cart-notification-root" />;
};
